import Vue from 'vue'

export class WebSocketMessage {
  topic: string;
  content: string;
  content_type: string;
}

class WebSocketService {

  handleMsg(data: any, topic: string) {
    let res = null;
    try {
      const json: WebSocketMessage = JSON.parse(data.data);
      if (json.topic === topic) {

        if (json.content_type === 'json') {
          try {
            res = JSON.parse(json.content);
          } catch (e) {
            //
          }
        }
        else if (json.content_type === 'string') {
          res = json.content;
        }
        else if (json.content_type === 'boolean') {
          res = json.content.toLowerCase() === 'true';
        }
      }

    } catch (e) {
      //
    }

    return res
  }

}

export default new WebSocketService();
